<template>
  <div class="page-about-school">
    <div class="info-block">
      <p class="info-item" v-for="(text, index) in $t('pages.about.info-list')" :key="index">
        {{ text }}
      </p>
      <ul class="info-list">
        <li v-for="(text, index) in $t('pages.about.presentations-list')" :key="index">
          {{ text }}
        </li>
      </ul>
      <MainSponsors class="hide-mobile" />
    </div>
    <div class="info-block stage-block">
      <div class="stage-title">
        {{ $t('pages.about.stage.title') }}
      </div>
      <div class="stage-list">
        <div class="stage-item" v-for="(text, index) in $t('pages.about.stage.list')" :key="index">
          <img class="stage-item-icon" :src="getStageItemIcon(index + 1)" alt="" />
          <div class="stage-item-body">
            <div v-if="index === $t('pages.about.stage.list').length - 1" class="stage-item-badge">
              {{ $t('pages.about.stage.current-stage-tag') }}
            </div>
            <div class="stage-item-text">
              {{ text }}
            </div>
          </div>
        </div>
      </div>
      <MainSponsors class="hide-pc" />
    </div>
  </div>
</template>

<script>
import MainSponsors from '@/components/MainSponsors'
export default {
  name: 'About',
  components: { MainSponsors },
  methods: {
    getStageItemIcon(number) {
      try {
        return require(`@/assets/icons/about-step-${number}.svg`)
      } catch (e) {
        return null
      }
    },
  },
}
</script>

<style lang="scss">
.page-about-school {
  @include PC {
    display: grid;
    grid-template-columns: 55% 1fr;
    grid-gap: 20px;
  }

  .block {
    padding: 25px;

    @include mobile {
      border-radius: 0;
    }
  }

  .info-block {
    padding: 30px 50px;
    background: #ffffff;
    box-shadow: 0 12px 21px rgba(204, 215, 230, 0.19);
    border-radius: 10px;

    font-weight: 400;
    font-size: 15px;
    line-height: 157.5%;
    color: #474747;

    @include mobile {
      padding: 20px 40px;
      margin-top: 16px;

      &:last-child {
        margin-top: 0;
      }
    }
  }

  .info-item {
    margin-bottom: 12px;

    @include mobile {
      margin-bottom: 15px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .info-list {
    margin: 6px 0 0;
    padding-left: 20px;

    @include mobile {
      margin-top: 15px;
    }
  }

  .stage-block {
    @media (min-width: 1200px) {
      padding-bottom: 50px;
      padding-right: 72px;
    }

    @include mobile {
      margin-top: 56px;
    }
  }

  .stage-title {
    margin-bottom: 30px;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color: #474747;
  }

  .stage-list {
    display: grid;
    grid-gap: 60px;

    .stage-item {
      display: flex;
      align-items: flex-start;

      &-icon {
        margin-right: 18px;
        flex-shrink: 0;
      }

      &-body {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      &-badge {
        margin-bottom: 12px;
        padding: 3px 7px;

        background: rgba(204, 215, 230, 0.3);
        border-radius: 5px;

        font-weight: 600;
        font-size: 12px;
        line-height: 147.5%;
        color: #474747;

        @include mobile {
          margin-bottom: 5px;
        }
      }

      &-text {
      }
    }
  }
}
</style>
